import $ from "jquery";

function CaptchaAccepted() {
    $('#loginBtn').prop("disabled", false);
}

function handleFormSubmit(formId: string) {
    $(document).on('submit', formId, function (e) {
        const captchaResult = CheckCaptcha();
        if (!captchaResult) {
            $("#dvCapthaError").css('display', 'block');
            e.preventDefault();
        } else {
            $("#dvCapthaError").css('display', 'none');
        }
    });
}

handleFormSubmit("#LogInForm");
handleFormSubmit("#RegForm");

function CheckCaptcha() {
    const captcha = $('textarea[name=g-recaptcha-response]').val();
    if (typeof (captcha) === 'undefined' || captcha === null || captcha == "") {
        return false;
    }
    return true;
}